import { render, staticRenderFns } from "./Woordjes-leren.vue?vue&type=template&id=21d7581c&scoped=true&"
import script from "./Woordjes-leren.vue?vue&type=script&lang=js&"
export * from "./Woordjes-leren.vue?vue&type=script&lang=js&"
import style0 from "./Woordjes-leren.vue?vue&type=style&index=0&id=21d7581c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7581c",
  null
  
)

export default component.exports